import { Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";

/**
 * @param {import(".").RenderSelectedOptionParams} props
 */
function CommonSelectedOption(props) {
  const {
    item,
    itemValue,
    removeValue,
    resolveItemName,
    hydrationDone,
    isInPopover,
  } = props;

  return (
    <Tag
      flexShrink={0}
      flexGrow={1}
      w={isInPopover ? "full" : undefined}
      overflow="hidden">
      <TagLabel flexGrow={1}>
        {(item && resolveItemName({ item })) ?? (hydrationDone && itemValue)}
      </TagLabel>

      <TagCloseButton
        tabIndex={isInPopover ? 0 : -1}
        onClick={(event) => {
          event.stopPropagation();
          removeValue({ value: itemValue });
        }}
      />
    </Tag>
  );
}

export default CommonSelectedOption;
